// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__smSTb","label":"CategoryService_label__1jTQn","location":"CategoryService_location__23Tru"};